import { logger as datadogLogger } from "../datadog";

/**
 * Creates a logger function for a specific source/component
 *
 * @param {string} source - The name of the source/component generating the log
 * @returns {Function} A logging function that accepts any number of messages
 *
 * The returned function:
 * - Logs to console with [rinsed][customer_app][source] prefix
 * - Stores logs in window.rinsed_logs (limited to last 100 entries) for debugging
 * - Sends logs to Datadog when available
 */
export function makeLogger(source) {
  return (...messages) => {
    console.log(`[rinsed][customer_app][${source}]`, ...messages);

    // keep logs in `window.rinsed_logs` also.
    // when testing on an iPhone it's hard to get all the logs, because you can't open the dev console on your mac until
    // after the app has already started, and you've missed some logs.
    try {
      window.rinsed_logs = window.rinsed_logs || [];
      window.rinsed_logs = window.rinsed_logs.slice(-100); // keep only the most recent logs
      window.rinsed_logs.push(messages);
    } catch (e) {
      console.error("Error with rinsed_logs in pwa_logger:", e);
    }

    // log to datadog, if datadogLogger isn't short circuited to console.log
    try {
      if (datadogLogger.log !== console.log) {
        const formattedMessage = messages
          .map((msg) => {
            if (msg === null || msg === undefined) {
              return String(msg);
            }
            try {
              return typeof msg === "object" ? JSON.stringify(msg) : String(msg);
            } catch {
              return "[Unserializable Object]";
            }
          })
          .join(" ");

        datadogLogger.log(formattedMessage, { rinsed: { customer_app: true, source } });
      }
    } catch (e) {
      console.error("Error with datadogLogger in pwa_logger:", e);
    }
  };
}
